import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { LazyArtistFooter } from '../Artist';

export function FooterRouter() {
  return (
    <Switch>
      <Route path="/artist/:artistId" component={LazyArtistFooter} />
      <Route path="/team/accept-invite" component={() => null} />
      <Route path="/team/:teamType/:teamId" component={LazyArtistFooter} />
      <Route path="/subscribe" component={LazyArtistFooter} />
      <Route path="/settings" component={LazyArtistFooter} />
    </Switch>
  );
}
